import { render, staticRenderFns } from "./HistoricalDistributorFilter.vue?vue&type=template&id=57561890&scoped=true&"
import script from "./HistoricalDistributorFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalDistributorFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57561890",
  null
  
)

export default component.exports